import React, { useEffect } from 'react';
import './Timer.css';

const Timer = ({ timeLeft, setTimeLeft, onTimeUp }) => {
  useEffect(() => {
    // 타이머가 0이 되면 게임 종료
    if (timeLeft <= 0) {
      onTimeUp();
      return;
    }

    // 1초마다 타이머 감소
    const timerInterval = setInterval(() => {
      setTimeLeft(prevTime => prevTime - 1);
    }, 1000);

    return () => clearInterval(timerInterval);
  }, [timeLeft, setTimeLeft, onTimeUp]);

  // 타이머 색상 계산 (시간이 적을수록 빨간색으로 변경)
  const getTimerColor = () => {
    if (timeLeft <= 10) return 'red';
    if (timeLeft <= 30) return 'orange';
    return 'green';
  };

  return (
    <div className="timer">
      <span className="timer-label">시간:</span>
      <span className={`timer-value ${getTimerColor()}`}>{timeLeft}</span>
    </div>
  );
};

export default Timer;
